import React, { useState } from "react";
import styled from "styled-components";
import AddNewTaskModal from "../AddNewTaskModel";

const ColumnHeader = ({
  column,
  showCompletedType,
  onToggleCompletedView,
  showGBorder,
  isAchievecolumn,
  onUpdate,
}) => {
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);

  // Map column IDs to their corresponding levels
  const getLevelFromColumnId = (columnId) => {
    const levelMap = {
      hitList: "HIT List",
      mitList: "MIT List",
      doList: "Do List",
    };
    return levelMap[columnId] || "";
  };

  if (column.id === "completedList") {
    return (
      <CompletedHeaderContainer>
        <ToggleContainer>
          <ToggleButton
            active={showCompletedType === "done"}
            onClick={() => onToggleCompletedView("done")}
          >
            Done ({column.doneCount || 0})
          </ToggleButton>
          <ToggleButton
            active={showCompletedType === "achieved"}
            onClick={() => onToggleCompletedView("achieved")}
          >
            Achieved ({column.achievedCount || 0})
          </ToggleButton>
        </ToggleContainer>
      </CompletedHeaderContainer>
    );
  }

  return (
    <>
      <HeaderContainer>
        <div
          className="kanban-header-custom tasks-kanban"
          style={{
            color: "white",
            border: showGBorder ? "1px solid #2AD674" : "",
          }}
        >
          <div
            className="kanban-header-title"
            style={{
              width: isAchievecolumn ? "193px" : "",
            }}
          >
            <div className="d-flex kanban-text-head justify-content-between align-items-center gap-3">
              <span className="light-header-h1 kanban-text-head">
                {column.title}
              </span>
              <span className="light-header-h1 kanban-text-head">
                ({column.count})
              </span>
            </div>
          </div>
          {!showGBorder && (
            <img
              src="/icons/add-task-management.svg"
              alt="Add task"
              style={{ cursor: "pointer" }}
              onClick={() => setShowAddTaskModal(true)}
            />
          )}
        </div>
        {(column.id === "mitList" || column.id === "doList") && (
          <ProgressContainer>
            <div className="kanban-task-progress-bar">
              <div
                className="kanban-task-progressed"
                style={{ width: `${column.progress || 0}%` }}
              ></div>
            </div>
            <h4
              className="text-body-b4 mb-0 text-end"
              style={{ color: "#c8ced3" }}
            >
              {column.progress || 0}%
            </h4>
          </ProgressContainer>
        )}
      </HeaderContainer>

      {/* Add Task Modal */}
      {showAddTaskModal && (
        <AddNewTaskModal
          show={showAddTaskModal}
          onClose={() => setShowAddTaskModal(false)}
          initialLevel={getLevelFromColumnId(column.id)}
          onUpdate={onUpdate}
        />
      )}
    </>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CompletedHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ToggleContainer = styled.div`
  display: flex;
  background: rgba(42, 47, 53, 0.8);
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
`;

const ToggleButton = styled.button`
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: ${(props) =>
    props.active ? "rgba(92, 224, 160, 0.2)" : "transparent"};
  color: ${(props) => (props.active ? "#5CE0A0" : "#C8CED3")};
  cursor: pointer;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  transition: all 0.2s ease;

  &:hover {
    background: rgba(92, 224, 160, 0.1);
  }
`;

const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default ColumnHeader;
